export const budgetTypes = [
  { label: "Público", value: "PUBLIC" },
  { label: "Propio", value: "OWN" },
  { label: "Privado", value: "PRIVATE" }
]
